import React from "react";
import ReactDom from "react-dom";
import Modal from "react-modal";
import style from "../style/alert.module.css";

export default function Alert({ isOpen, setOpen,title,mensagem}) {
  let subtitle;

  function abriModal() {
    setOpen(true);
  }

  function fecharModal() {
    setOpen(false);
  }

  return (
    <div className={style.container}>
      <Modal
        isOpen={isOpen}
        onRequestClose={fecharModal}
        className={style.content}
        contentLabel="Cuidado"
      >
        <h2 className={style.title}>{title}</h2>
        <p className={style.mensagem}>{mensagem}</p>
        <div className={style.positionbutton}>
          <button 
          className={style.button}
          onClick={fecharModal}>
            Fechar
          </button>
        </div>
      </Modal>
    </div>
  );
}
